import * as React from 'react'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'

interface InfoDialogProps {
  isInfoDialogOpen: boolean
  amount?: number
  isJobTimeInfo?: boolean

  handleInfoDialogClose: () => void
}

interface InfoDialogState { }

export class InfoDialog extends React.Component<InfoDialogProps, InfoDialogState> {
  constructor(props: any) {
    super(props)
  }

  componentWillReceiveProps(nextProps: any) {
    if (this.props !== nextProps) {
      this.setState({
        isInfoDialogOpen: nextProps.isInfoDialogOpen
      })
    }
  }

  onKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.props.handleInfoDialogClose()
    }
  }

  render() {
    return (
      <Dialog
        open={this.props.isInfoDialogOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="job-cancel-dialog"
        classes={{ paper: 'job-cancel-dialog-paper' }}
      >
        <DialogTitle id="alert-dialog-title">
          {
            this.props.isJobTimeInfo ?
              StringResources.getString(Strings.Components.InfoDialog.Titles.setAvailability)
              :
              StringResources.getString(Strings.Components.InfoDialog.Titles.bidAccepted)
          }
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {
              this.props.isJobTimeInfo ?
                StringResources.getString(Strings.Components.InfoDialog.Content.setAvailability)
                :
                StringResources.getString(Strings.Components.InfoDialog.Content.bidAccepted, this.props.amount)
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={this.props.handleInfoDialogClose}
            color="primary"
            tabIndex={0}
            onKeyDown={this.onKeyDown}
            autoFocus={true}
          >
            {StringResources.getString(Strings.Components.InfoDialog.Buttons.ok)}
          </Button>
        </DialogActions>
      </Dialog >
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/InfoDialog.tsx